module.exports = __webpack_public_path__ + "img/sample_img_phone_ani.b09dd943.png";